import { useNavigate, useSearchParams } from 'react-router-dom'
import { LoginCard } from '@/components/ui'
import { useAuthStore } from '@/stores/auth.ts'

const errorMessages: Record<string, string> = {
  m365_denied: 'Microsoft-Anmeldung wurde abgebrochen.',
  m365_no_code: 'Keine Autorisierung von Microsoft erhalten.',
  m365_no_email: 'Keine E-Mail-Adresse im Microsoft-Konto gefunden.',
  m365_error: 'Fehler bei der Microsoft-Anmeldung. Bitte erneut versuchen.',
  m365_invalid_client: 'M365-Konfigurationsfehler: Client-ID oder Client-Secret ist ungültig.',
  m365_invalid_grant: 'M365-Autorisierungscode ist abgelaufen oder ungültig. Bitte erneut versuchen.',
  m365_token_error: 'Fehler beim Token-Austausch mit Microsoft. Bitte Redirect-URI und Client-Secret prüfen.',
  m365_graph_error: 'Fehler beim Abrufen des Microsoft-Profils. Bitte API-Berechtigungen prüfen.',
  m365_not_configured: 'M365 SSO ist nicht konfiguriert. Bitte Umgebungsvariablen prüfen.',
  m365_db_error: 'Datenbankfehler bei der Anmeldung. Bitte Datenbankverbindung prüfen.',
  account_disabled: 'Dieses Konto wurde deaktiviert.',
  account_pending: 'Dein Account wurde noch nicht freigegeben. Bitte wende dich an einen Administrator.',
}

export function LoginPage() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const login = useAuthStore((s) => s.login)

  return (
    <LoginCard
      title="implec Systemhausmanager"
      subtitle="Anmeldung"
      m365LoginUrl="/api/auth/m365/login"
      errorMessages={errorMessages}
      onPasswordLogin={async (email, password) => {
        await login(email, password)
        const returnPath = searchParams.get('return')
        navigate(returnPath && returnPath.startsWith('/') ? returnPath : '/dashboard')
      }}
    />
  )
}
